// extracted by mini-css-extract-plugin
export default {"changer":"style_changer__IcPlZ","changer__item":"style_changer__item__vVJ4U","changer__item_active":"style_changer__item_active__vIDcC"};